import { createContext, useContext } from 'react';
import type { Chat } from '@trinity/chat';

export const AttachmentContext = createContext<Chat.Attachment.Item | null>(null);

export const useAttachmentContext = <T extends Chat.Attachment.Item = Chat.Attachment.Item>() => {
  const context = useContext(AttachmentContext);
  if (!context) {
    throw new Error('useAttachmentContext must be used within a AttachmentContext.Provider');
  }
  return context as T;
};